<template>
  <div class="main-div">
<!--    <hero v-if="!['login', 'Admin Login'].includes($route.name)"></hero>-->
    <base-nav
      class="navbar-top navbar-horizontal"
      :class="[
          { 'bg-gradient-primary': $store.state.companyColor === null },
          {'navbar-transparent' : ['Company', 'QuickBook'].includes($route.name)}
      ]"
      :style="
          {
            background: $store.state.companyColor ?? '',
            position : ['Company', 'QuickBook'].includes($route.name) ? 'absolute' : '',
            width : ['Company', 'QuickBook'].includes($route.name) ? '100%' : '',
            padding : ['Company', 'QuickBook'].includes($route.name) ? '1rem 0' : ''
          }
      "
      containerClasses="px-4 container"
      expand
    >

<!--      Mobile menu-->
      <template v-slot="{ closeMenu }">
        <!-- Collapse header -->
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-9 collapse-brand">
              <router-link to="/">
                <img src="../assets/logo1.png" />
                <span class="text-lg ml-2 font-weight-bolder">AppointMe</span>
              </router-link>
            </div>
            <div class="col-3 collapse-close mb-only">
              <button
                  type="button"
                  @click="toggled = false"
                  class="navbar-toggler"
                  aria-label="Toggle sidenav"
              >
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
        <!-- Navbar items -->
        <ul class="navbar-nav ml-auto mb-only">
          <li class="nav-item float-left">
            <router-link v-if="$store.state.user.claims !== null" to="/profile" class="nav-link dropdown-item p-2">
              <i class="fa fa-user-circle pr-2" style="font-size: 20px;"></i>{{ $t("Profile") }}
            </router-link>

          </li>
          <li class="nav-item float-left">
            <router-link v-if="$store.state.user.claims !== null" to="/appointments" class="nav-link dropdown-item p-2"><i class="fas fa-calendar-day pr-2" style="font-size: 20px;"></i>{{ $t("Appointments") }}</router-link>

          </li>
          <li class="nav-item float-left">
            <base-button type="link" v-if="$store.state.user.claims !== null" @click="logout()" class="nav-link dropdown-item p-2"><i class="fa fa-sign-out-alt pr-2" style="font-size: 20px;"></i>{{$t("Log Out")}}</base-button>
            <base-button type="link" v-if="$store.state.user.claims === null && !['login'].includes($route.name)"  @click="login()" class="nav-link dropdown-item p-2"><i class="fa fa-sign-out-alt pr-2" style="font-size: 20px;"></i>{{$t("Log In")}}</base-button>
          </li>
          <hr style="width: 100%;margin-top: 1rem;margin-bottom: 1rem;">
          <li class="nav-item float-left">
            <a class="nav-link nav-link-icon" href="https://www.facebook.com/AppointMeCy/">
              <i style="font-size: 25px;" class="fab fa-facebook-square"></i><span class="p-2 mb-only"> Facebook</span>
            </a>
          </li>
          <li class="nav-item float-left">
            <a class="nav-link nav-link-icon" href="https://www.instagram.com/appointmeapp/">
              <i style="font-size: 25px;" class="fab fa-instagram"></i> <span class="p-2 mb-only"> Instagram</span>
            </a>
          </li>
        </ul>

        <div class=" locale-changer float-right smHide">
          <!--            <select class="btn btn-dark btn-sm" right size="sm" @change="setLocale($event)" style="cursor: pointer;appearance: none;-webkit-appearance: none; -moz-appearance: none;">-->
          <!--              <option :value="lang.value" class="btn" v-for="(lang, i) in locales" :selected="$store.state.locale === lang.value" v-bind:key="i">{{ lang.label }} </option>-->
          <!--            </select>-->

          <base-dropdown v-if="$store.state.user.claims !== null" :hideArrow="true" tag="li" class="nav-item float-left">
            <template v-slot:title>
              <a
                  class="d-flex align-items-center"
                  style="cursor: pointer;height: 33px"
                  data-toggle="dropdown"
                  @click="closeMenu"
              >
<!--                    <span class="avatar avatar-sm rounded-circle float-right bg-white">-->
                    <i class="fa fa-user-circle text-white text-lg"></i>
<!--                  </span>-->
                <span class="mb-0 pl-1 text-white mr-1 font-weight-bold d-block float-right smHide">{{ $store.state.user.data == null ? "" : $store.state.user.data.firstName }} {{$store.state.user.data == null ? "" : $store.state.user.data.lastName}}</span>
              </a>
            </template>

            <router-link v-if="$store.state.user.claims !== null" to="/profile" class="nav-link dropdown-item"><i class="fa fa-user-circle" style="font-size: 20px;"></i>{{ $t("Profile") }}</router-link>
            <router-link v-if="$store.state.user.claims !== null" to="/appointments" class="nav-link dropdown-item"><i class="fas fa-calendar-day" style="font-size: 20px;"></i>{{ $t("Appointments") }}</router-link>

            <base-button type="link" v-if="$store.state.user.claims !== null" @click="logout()" class="nav-link dropdown-item"><i class="fa fa-sign-out-alt" style="font-size: 20px;"></i>{{$t("Log Out")}}</base-button>
          </base-dropdown>
          <li v-if="$store.state.user.claims === null && !['login'].includes($route.name)" class="dropdown dropdown nav-item float-left pl-2" style="height: 33px;">
            <base-button type="link" @click="login()" class="nav-link text-white"><i class="fa fa-sign-out-alt" style="font-size: 20px;"></i>{{$t("Log In")}}</base-button>

          </li>

          <base-dropdown :hideArrow="true" tag="li" class="nav-item float-left pl-2" style="border-radius: 0;">
            <template v-slot:title>
              <a
                  class=" d-flex align-items-center"
                  style="cursor: pointer;height: 33px;"
                  data-toggle="dropdown"
              >
                <i class="fa fa-globe text-lg  text-white pr-1"></i>
                <span class="mb-0 text-white font-weight-bold d-block float-left smHide">
                  {{ $store.state.locale.toUpperCase() }}
                </span>

              </a>
            </template>
            <base-button type="link" @click="setLocale(locale.value)" class="nav-link dropdown-item" :class="{active : $store.state.locale.toUpperCase() === locale.value}" v-bind:key="locale.value" v-for="locale in locales">
                  {{locale.value}}
            </base-button>
          </base-dropdown>
<!--          <VueMultiselect-->
<!--              class="small-select float-right"-->
<!--              v-model="langSelected"-->
<!--              :showLabels="false"-->
<!--              :showPointer="false"-->
<!--              :options="locales"-->
<!--              :searchable="false"-->
<!--              :close-on-select="true"-->
<!--              tag-placeholder="Add this as new tag"-->
<!--              :allow-empty="false"-->
<!--              @update:model-value="setLocale()"-->
<!--              label="value"-->
<!--              :placeholder="$store.state.locale"-->
<!--              track-by="value"-->
<!--          />-->
        </div>
      </template>
<!-- End Mobile menu-->


    </base-nav>
    <!-- Navbar -->
    <div>
      <router-view v-slot="{ Component }">
        <keep-alive include="UserAppointments">
          <component :is="Component" :key="$route.fullPath"></component>
        </keep-alive>
      </router-view>
    </div>

    <footer class="py-5">
      <div class="container">
        <div class="row align-items-center justify-content-xl-between">
          <div class="col-xl-6">
            <div class="copyright text-center text-xl-left text-muted">
              &copy; {{ year }}
<!--              <a-->
<!--                  href="https://www.pine-native.com"-->
<!--                class="font-weight-bold ml-1"-->
<!--                target="_blank"-->
<!--                >-->
                PineNative
<!--              </a>-->
            </div>
          </div>
          <div class="col-xl-6">
            <ul
              class="nav nav-footer justify-content-center justify-content-xl-end"
            >
              <li class="nav-item  text-muted">
<!--                <a-->
<!--                    href="https://www.pine-native.com"-->
<!--                  class="nav-link"-->
<!--                  target="_blank"-->
<!--                  >-->
                v{{ version }}
<!--                </a>-->
              </li>
              <li class="nav-item  pl-2">
<!--                <a-->
<!--                  href="/about-us"-->
<!--                  class="nav-link"-->
<!--                  target="_blank"-->
<!--                  >-->
<!--                  {{$t("About Us")}}-->
<!--                </a>-->
              </li>
              <li class="nav-item  pl-2">
<!--                <a-->
<!--                  href="/blog"-->
<!--                  class="nav-link"-->
<!--                  target="_blank"-->
<!--                  >-->
<!--                  {{ $t("Blog") }}-->
<!--                </a>-->
              </li>
<!--              <li class="nav-item">-->
<!--                <a-->
<!--                  href="https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md"-->
<!--                  class="nav-link"-->
<!--                  target="_blank"-->
<!--                  >MIT License</a-->
<!--                >-->
<!--              </li>-->
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
// import BaseDropdown from "@/components/BaseDropdown";
// import VueMultiselect from 'vue-multiselect'
import packageData from '../../package.json';
import BaseButton from "@/components/BaseButton";
import BaseNav from "@/components/BaseNav";

export default {
  name: "top-layout",
  components: {
    BaseNav,
    BaseButton,
    // VueMultiselect
  },
  data() {
    return {
      version: null,
      langSelected: null,
      toggled: false,
      locales: [
        {label: 'English', value: 'EN'},
        {label: 'Ελληνικά', value: 'EL'},
        // {label: 'Russian', value: 'ru'}
      ],
      year: new Date().getFullYear(),
      showMenu: false,
    };
  },
  mounted() {
    this.version = packageData.version
    let localeSelected = this.locales.find( l => l.value === this.$store.state.locale.toUpperCase())

    if(localeSelected){
      this.langSelected = JSON.parse(JSON.stringify(localeSelected))
    }
  },
  methods: {
    setLocale (locale) {
      // this.$store.state.locale = value
      this.$i18n.locale = locale.toLowerCase()
      this.$store.dispatch('setLocale', locale.toLowerCase())
    },
    async logout() {
      this.closeMenu()

      let result = await this.$store.dispatch("signOut");
      console.log("logout result", result)
      if ( !['Company', 'QuickBook'].includes(this.$route.name)) {
        let theRoute = this.$router.currentRoute.value.fullPath
        this.$router.push({ name: "login", params: {beforeRoute: theRoute} });
      }
    },
    login() {
      this.closeMenu()
      let theRoute = this.$router.currentRoute.value.fullPath
      this.$router.push({ name: "login", params: {beforeRoute: theRoute} });
    },
    closeMenu() {
      this.toggled = false;
    },
  },
};
</script>
<style>
.locale-changer select {
  /*background: transparent;*/
  border: none;
  /*color: white;*/
}
.locale-changer{
  margin-left: auto !important;
  cursor: pointer;
  padding-top: 10px;}

.locale-changer select:focus-visible {
  outline: none;
}
.multiselect.small-select .multiselect__select {
  padding: 4px 6px;
  height: 30px;
  width: 30px;
}

.multiselect.small-select .multiselect__tags {
  max-height: 30px;
  padding: 5px 27px 0 4px;
  min-height: 30px;
  background: unset;
}

.multiselect{
  width: 60px !important;
}

span.multiselect__single {
  color: white;
  background: unset;
}
.multiselect__select:before{
  color: white !important;
}

@media(min-width: 767px)  {
  .mb-only{
    display: none !important;
  }
}

ul.dropdown-menu.show {
  padding: 0;
}
a.active.router-link-exact-active.nav-link.dropdown-item {
  color: white !important;
}
ul.dropdown-menu.show {
  border-radius: 0px 0 5px 5px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>